import { useEffect } from 'react';
import { APP_CONFIG } from '../helpers/constants';

const AppTitle: React.FC = () => {
  useEffect(() => {
    // Set document title
    document.title = APP_CONFIG.NAME;
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', APP_CONFIG.NAME);
    }
  }, []);

  return null; // This component doesn't render anything
};

export default AppTitle; 